import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-area" }
const _hoisted_2 = { class: "main-view-container" }
const _hoisted_3 = { class: "active-filters-bar" }
const _hoisted_4 = { class: "filter-chips" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "no-filters-label"
}
const _hoisted_7 = { class: "subtabs-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "tab-title-container"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "list-view-content"
}
const _hoisted_11 = {
  key: 1,
  class: "list-view-content"
}
const _hoisted_12 = {
  key: 2,
  class: "line-view-content"
}
const _hoisted_13 = { class: "popup-header" }
const _hoisted_14 = { class: "popup-header" }
const _hoisted_15 = { class: "popup-header-title" }
const _hoisted_16 = { class: "edit-document-popup-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentDetails = _resolveComponent("DocumentDetails")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DocumenteView = _resolveComponent("DocumenteView")!
  const _component_LiniiDocumenteView = _resolveComponent("LiniiDocumenteView")!
  const _component_LiniView = _resolveComponent("LiniView")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!
  const _component_SearchFilters = _resolveComponent("SearchFilters")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["documents-layout", { 'sidebar-collapsed': !_ctx.isSidebarVisible }])
  }, [
    _createElementVNode("aside", {
      class: _normalizeClass(["filters-sidebar", { 'sidebar-details-mode': !_ctx.isActiveSearchTab }])
    }, [
      (_ctx.activeDocumentTab && _ctx.activeDocumentTab.Document)
        ? (_openBlock(), _createBlock(_component_DocumentDetails, {
            key: 0,
            ref: "documentDetailsRef",
            document: _ctx.activeDocumentTab.Document,
            onCloseSidebar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSidebarVisible = false)),
            onRefreshDocument: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshDocumentData($event))),
            onDirtyCountChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeDocumentTab.HeaderDirtyCount = $event))
          }, null, 8, ["document"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "filters-bar-label" }, "Filtre active:", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFilters, (filter) => {
              return (_openBlock(), _createElementBlock("span", {
                key: filter.key,
                class: "filter-chip filter-chip--clickable",
                onClick: ($event: any) => (_ctx.openFilterTab(filter.key))
              }, [
                _createTextVNode(_toDisplayString(filter.label) + " ", 1),
                _createVNode(_component_DxButton, {
                  icon: "close",
                  "styling-mode": "text",
                  class: "chip-close-btn",
                  onClick: ($event: any) => (_ctx.onClearFilterClick($event, filter.key))
                }, null, 8, ["onClick"])
              ], 8, _hoisted_5))
            }), 128)),
            (_ctx.activeFilters.length === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Niciun filtru activ"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.activeFilters.length > 0)
            ? (_openBlock(), _createBlock(_component_DxButton, {
                key: 0,
                text: "Șterge toate",
                "styling-mode": "text",
                class: "clear-all-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearAllFilters()))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DxTabPanel, {
            "data-source": _ctx.allTabs,
            "selected-index": _ctx.activeSubTab,
            onOptionChanged: _ctx.onSubTabChanged,
            height: "100%",
            class: "subtabs-panel",
            "scrolling-enabled": true,
            "show-nav-buttons": true,
            "repaint-changes-only": true,
            "defer-rendering": true
          }, {
            title: _withCtx(({ data, index }) => [
              (data && data.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(data.title), 1),
                    (data.tabType === 'document' && _ctx.tabDirtyTotal(data) > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "tab-dirty-badge",
                          title: `${_ctx.tabDirtyTotal(data)} câmp(uri) modificate nesalvate`
                        }, _toDisplayString(_ctx.tabDirtyTotal(data)), 9, _hoisted_9))
                      : _createCommentVNode("", true),
                    (data.tabType === 'document')
                      ? (_openBlock(), _createBlock(_component_DxButton, {
                          key: 1,
                          icon: "close",
                          text: "",
                          "styling-mode": "text",
                          onClick: ($event: any) => (_ctx.closeSubTab(index))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            item: _withCtx(({ data }) => [
              (data.tabType === 'search' && data.searchTarget === 'documente')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_DocumenteView, {
                      "initial-filters": _ctx.sharedSearchParams,
                      onSelectDocument: _ctx.openDocumentDetailTab,
                      onToggleFilters: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSidebar($event))),
                      ref: "documenteViewRef"
                    }, null, 8, ["initial-filters", "onSelectDocument"])
                  ]))
                : (data.tabType === 'search' && data.searchTarget === 'linii')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_LiniiDocumenteView, {
                        "initial-filters": _ctx.sharedSearchParams,
                        onOpenDocument: _ctx.openDocumentDetailTab,
                        onToggleFilters: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSidebar($event))),
                        ref: "liniiViewRef"
                      }, null, 8, ["initial-filters", "onOpenDocument"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (data.Document)
                        ? (_openBlock(), _createBlock(_component_LiniView, {
                            key: 0,
                            document: data.Document,
                            "sidebar-open": _ctx.isSidebarVisible,
                            onToggleDetails: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSidebarVisible = !_ctx.isSidebarVisible)),
                            onOpenEditDocument: _ctx.openDocumentEdit,
                            onRefreshDocument: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refreshDocumentData($event))),
                            onDirtyCountChange: ($event: any) => (data.LiniiDirtyCount = $event)
                          }, null, 8, ["document", "sidebar-open", "onOpenEditDocument", "onDirtyCountChange"]))
                        : _createCommentVNode("", true)
                    ]))
            ]),
            _: 1
          }, 8, ["data-source", "selected-index", "onOptionChanged"])
        ])
      ])
    ]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isFilterPopupVisible,
      "onUpdate:visible": _cache[10] || (_cache[10] = val => _ctx.isFilterPopupVisible = val),
      "show-title": true,
      width: "850",
      height: "650",
      position: "center",
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": false,
      "wrapper-attr": { class: 'era-filters-popup' }
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-filter" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Filtre căutare"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, "Rafinează rezultatele din grid")
            ])
          ], -1)),
          _createVNode(_component_DxButton, {
            icon: "close",
            "styling-mode": "text",
            class: "popup-close-btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isFilterPopupVisible = false))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_SearchFilters, {
          onClicked: _ctx.onClickChild,
          onCloseSidebar: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isFilterPopupVisible = false)),
          ref: "searchFiltersRef"
        }, null, 8, ["onClicked"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isEditDocumentPopupVisible,
      "onUpdate:visible": _cache[15] || (_cache[15] = val => _ctx.isEditDocumentPopupVisible = val),
      "show-title": true,
      width: "640",
      height: "560",
      position: "center",
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": false,
      "wrapper-attr": { class: 'era-edit-document-popup' }
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "dx-icon-edit popup-header-icon" }, null, -1)),
          _createElementVNode("span", _hoisted_15, "Editare document" + _toDisplayString(_ctx.activeDocumentTab?.Document?.Numar ? ` — #${_ctx.activeDocumentTab.Document.Numar}` : ''), 1),
          _createVNode(_component_DxButton, {
            icon: "close",
            "styling-mode": "text",
            class: "popup-close-btn",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isEditDocumentPopupVisible = false))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          (_ctx.activeDocumentTab && _ctx.activeDocumentTab.Document)
            ? (_openBlock(), _createBlock(_component_DocumentDetails, {
                key: 0,
                ref: "documentDetailsEditRef",
                document: _ctx.activeDocumentTab.Document,
                "hide-title": true,
                onCloseSidebar: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isEditDocumentPopupVisible = false)),
                onRefreshDocument: _cache[13] || (_cache[13] = ($event: any) => (_ctx.refreshDocumentData($event))),
                onDirtyCountChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.activeDocumentTab.HeaderDirtyCount = $event))
              }, null, 8, ["document"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}